import { blue, ColorsWithRatio, grey } from "@faro-lotv/flat-ui";

/** Default color of waypoints */
export const DEFAULT_WAYPOINT_COLOR = blue[500];

/** Color used for the elements with invalid height */
export const INVALID_VALUE_COLOR = grey[900];

/** Color used for the elements with invalid height */
export const DISABLED_VALUE_COLOR = grey[500];

/** Color gradient used for the waypoints colorization by altitude */
export const WAYPOINTS_ALTITUDE_GRADIENT: ColorsWithRatio = [
  {
    color: blue[500],
    ratio: 0.0,
  },
  {
    color: "#8E306D",
    ratio: 0.5,
  },
  {
    color: "#E1080B",
    ratio: 1.0,
  },
];

/** Color gradient used for the waypoints colorization by capture date */
export const WAYPOINTS_DATE_GRADIENT: ColorsWithRatio = [
  {
    color: blue[500],
    ratio: 0.0,
  },
  {
    color: "#189393",
    ratio: 0.5,
  },
  {
    color: "#12B059",
    ratio: 1.0,
  },
];
